var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { getRoleString, ERoleTypes } from '../../../types';
import { Delimiter } from '../../atoms/Delimiter';
import { addFoul, techKill } from '../../../api';
import { ModalWrapperNew } from '../../atoms/ModalWrapper/ModalWrapper';
import { ModalNew } from '../../atoms/Modal/Modal';
import { useAppSelector } from '../../../hooks';
import { selectShowRoles } from '../../../store/match';
const Title = styled.div `
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
`;
const Container = styled.div `
  display: flex;
  align-items: center;
`;
const PlayerContainer = styled(Container) `
  justify-content: space-between;
  padding: 8px 0;
  width: 100%;
  height: 100%;
`;
const ScrollContainer = styled.div `
  width: 100%;
  height: 100%;
  overflow-x: visible;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0px !important;
    height: 0px !important;
    -webkit-appearance: none;
    display: none;
  }
`;
const PlayerImg = styled.img `
  width: 40px;
  height: 40px;
  border-radius: 50%;
  user-select: none;
  object-fit: cover;
`;
const PlayerFoulImg = styled.img `
  width: 70px;
  height: 70px;
  border-radius: 50%;
`;
const PlayerRole = styled.div `
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.8);
`;
const PlayerFouls = styled.div `
  font-size: 12px;
  line-height: 17px;
  color: ${({ color }) => color};
`;
const PlayerFoulsModal = styled.span `
  font-weight: 700;
  color: ${({ color }) => color};
`;
const PlayerNick = styled.div `
  display: flex;
  align-items: flex-end;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
`;
const PlayerFoulNick = styled.span `
  font-weight: 700;
  color: #ffd643;
`;
const FoulText = styled.div `
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;
const ModalWrapper = styled(ModalWrapperNew) `
  width: 520px;
  padding: 60px 80px;
`;
export function PlayerActions({ players, matchId, reload }) {
    const showRoles = useAppSelector(selectShowRoles);
    const [isLoading, setIsLoading] = useState(false);
    const [foulModal, setFoulModal] = useState(false);
    const [killPlayerModal, setKillPlayerModal] = useState(false);
    const [foulPlayer, setFoulPlayer] = useState(null);
    const onFoulClick = () => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        const foulEvents = yield addFoul((foulPlayer === null || foulPlayer === void 0 ? void 0 : foulPlayer.id) || '');
        yield reload();
        setFoulPlayer(null);
        setFoulModal(false);
        setIsLoading(false);
    });
    const onKillClick = () => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        const killEvents = yield techKill((foulPlayer === null || foulPlayer === void 0 ? void 0 : foulPlayer.id) || '', 'Убит ведущим вручную');
        yield reload();
        setFoulPlayer(null);
        setKillPlayerModal(false);
        setIsLoading(false);
    });
    return (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u0424\u043E\u043B\u044B" })), _jsx(Delimiter, { top: "37px" }), _jsxs(ScrollContainer, { children: [players.map((pm) => (_jsxs(PlayerContainer, { children: [_jsx(Container, { children: _jsxs("div", { children: [_jsxs(Typography, Object.assign({ variant: "h4" }, { children: [pm.player.gameName, pm.fouls && pm.fouls < 4 ? (_jsxs(_Fragment, { children: [_jsx(Delimiter, { right: "6px" }), _jsxs(Typography, Object.assign({ variant: "body1" }, { children: [pm.fouls, " \u0444\u043E\u043B", pm.fouls > 1 && 'a'] }))] })) : ('')] })), showRoles && (_jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: getRoleString((pm === null || pm === void 0 ? void 0 : pm.role) || ERoleTypes.CIVILIAN) })))] }) }, pm.id), _jsxs(Container, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: () => {
                                            setFoulPlayer(pm);
                                            setFoulModal(true);
                                        }, disabled: isLoading }, { children: "\u0424\u043E\u043B" })), _jsx(Delimiter, { right: "8px" }), _jsx(Button, Object.assign({ variant: "contained", onClick: () => {
                                            setFoulPlayer(pm);
                                            setKillPlayerModal(true);
                                        }, disabled: isLoading }, { children: "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0442\u0440\u0443\u043F" }))] })] }))), _jsx(Delimiter, { top: "30px" })] }), foulModal && foulPlayer && (_jsx(ModalNew, Object.assign({ close: true, onClose: () => {
                    setFoulModal(false);
                } }, { children: _jsxs(ModalWrapper, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0443 \u0444\u043E\u043B?" })), _jsx(Delimiter, { top: "16px" }), _jsx(FoulText, { children: _jsx(Typography, Object.assign({ variant: "h5" }, { children: `${foulPlayer.player.realName} 
                  ${foulPlayer.fouls < 1
                                    ? `не имеет ни одного фола.`
                                    : `уже имеет ${foulPlayer.fouls} фол${foulPlayer.fouls > 1 ? 'a.' : '.'}`}
                4 фола и игрок будет исключен из числа участников. Продолжить?` })) }), _jsx(Delimiter, { top: "40px" }), _jsxs(Container, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: () => setFoulModal(false), disabled: isLoading }, { children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })), _jsx(Delimiter, { right: "30px" }), _jsx(Button, Object.assign({ variant: "contained", onClick: () => onFoulClick(), disabled: isLoading }, { children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C" }))] })] }) }))), killPlayerModal && foulPlayer && (_jsx(ModalNew, Object.assign({ close: true, onClose: () => setKillPlayerModal(false) }, { children: _jsxs(ModalWrapper, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0430 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0442\u0440\u0443\u043F\u043E\u043C?" })), _jsx(Delimiter, { top: "16px" }), _jsx(Typography, Object.assign({ variant: "h5" }, { children: `Если сделать игрока ${foulPlayer.player.realName} 
              техническим трупом, он не сможет продолжить игру. Продолжить?` })), _jsx(Delimiter, { top: "40px" }), _jsxs(Container, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: () => setKillPlayerModal(false), disabled: isLoading }, { children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })), _jsx(Delimiter, { right: "30px" }), _jsx(Button, Object.assign({ variant: "contained", onClick: () => onKillClick(), disabled: isLoading }, { children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C" }))] })] }) })))] }));
}
